// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Reader_Class from "../Control.Monad.Reader.Class/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Restaumatic_Services_Storage from "../Restaumatic.Services.Storage/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var setJSONItem = /* #__PURE__ */ Restaumatic_Services_Storage.setJSONItem();
var getJSONItem = /* #__PURE__ */ Restaumatic_Services_Storage.getJSONItem();
var storeValueDyn = function (dictEncode) {
    var setJSONItem1 = setJSONItem(dictEncode);
    return function () {
        return function (dictMonadReader) {
            var asks = Control_Monad_Reader_Class.asks(dictMonadReader.MonadAsk0());
            return function (dictMonadFRP) {
                var bind = Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1());
                var subscribeDyn_ = Specular_FRP_Base.subscribeDyn_(dictMonadFRP);
                return function (key) {
                    return function (dyn) {
                        return bind(asks(function (v) {
                            return v.storage;
                        }))(function (storage) {
                            return subscribeDyn_(setJSONItem1(storage)(key))(dyn);
                        });
                    };
                };
            };
        };
    };
};
var storeValue = function (dictEncode) {
    var setJSONItem1 = setJSONItem(dictEncode);
    return function () {
        return function (dictMonadReader) {
            var asks = Control_Monad_Reader_Class.asks(dictMonadReader.MonadAsk0());
            return function (dictMonadFRP) {
                var MonadCleanup1 = dictMonadFRP.MonadCleanup1();
                var bind = Control_Bind.bind((MonadCleanup1.Monad0()).Bind1());
                var subscribeEvent_ = Specular_FRP_Base.subscribeEvent_(dictMonadFRP.MonadEffect0())(MonadCleanup1);
                return function (key) {
                    return function (change) {
                        return bind(asks(function (v) {
                            return v.storage;
                        }))(function (storage) {
                            return subscribeEvent_(setJSONItem1(storage)(key))(change);
                        });
                    };
                };
            };
        };
    };
};
var storeSessionValue = function (dictEncode) {
    var setJSONItem1 = setJSONItem(dictEncode);
    return function () {
        return function (dictMonadReader) {
            var asks = Control_Monad_Reader_Class.asks(dictMonadReader.MonadAsk0());
            return function (dictMonadFRP) {
                var MonadCleanup1 = dictMonadFRP.MonadCleanup1();
                var bind = Control_Bind.bind((MonadCleanup1.Monad0()).Bind1());
                var subscribeEvent_ = Specular_FRP_Base.subscribeEvent_(dictMonadFRP.MonadEffect0())(MonadCleanup1);
                return function (key) {
                    return function (change) {
                        return bind(asks(function (v) {
                            return v.sessionStorage;
                        }))(function (storage) {
                            return subscribeEvent_(setJSONItem1(storage)(key))(change);
                        });
                    };
                };
            };
        };
    };
};
var readStoredValue = function (dictDecode) {
    var getJSONItem1 = getJSONItem(dictDecode);
    return function () {
        return function (dictMonadReader) {
            var asks = Control_Monad_Reader_Class.asks(dictMonadReader.MonadAsk0());
            return function (dictMonadEffect) {
                var bind = Control_Bind.bind((dictMonadEffect.Monad0()).Bind1());
                var liftEffect = Effect_Class.liftEffect(dictMonadEffect);
                return function (key) {
                    return bind(asks(function (v) {
                        return v.storage;
                    }))(function (storage) {
                        return liftEffect(getJSONItem1(storage)(key));
                    });
                };
            };
        };
    };
};
var readSessionStoredValue = function (dictDecode) {
    var getJSONItem1 = getJSONItem(dictDecode);
    return function () {
        return function (dictMonadReader) {
            var asks = Control_Monad_Reader_Class.asks(dictMonadReader.MonadAsk0());
            return function (dictMonadEffect) {
                var bind = Control_Bind.bind((dictMonadEffect.Monad0()).Bind1());
                var liftEffect = Effect_Class.liftEffect(dictMonadEffect);
                return function (key) {
                    return bind(asks(function (v) {
                        return v.sessionStorage;
                    }))(function (storage) {
                        return liftEffect(getJSONItem1(storage)(key));
                    });
                };
            };
        };
    };
};
export {
    readStoredValue,
    storeValue,
    storeValueDyn,
    readSessionStoredValue,
    storeSessionValue
};
